/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { EmailServerSettingsStore } from './email-server-settings-store';

export const EmailServerSettingsStoreContext = createContext<EmailServerSettingsStore>({} as EmailServerSettingsStore);
